// extracted by mini-css-extract-plugin
export default {"link":"styles_link__zqkUq","text":"styles_text__KvQ7I"};